import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { Button } from '~/components/ui/Button';
import { useTranslate } from '@tolgee/react';

/**
 * Honest error state shown when Clerk never becomes ready (isLoaded stays
 * false beyond the timeout) — instead of an infinite spinner.
 *
 * Reuses the existing EmptyState/Button primitives (same rendering mechanism
 * as ErrorWidget/NotFoundWidget) so no bespoke UI is invented here.
 */
export function AuthLoadErrorWidget() {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <EmptyState
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        }
        title={t('authloaderrorwidget_title', 'Anmeldung nicht möglich')}
        description={t(
          'authloaderrorwidget_description',
          'Die Anmeldung konnte nicht geladen werden. Bitte Seite neu laden oder Browser-Erweiterungen/Adblocker prüfen.',
        )}
        actions={
          <Button
            primary
            onClick={() => window.location.reload()}
          >
            {t('authloaderrorwidget_retry', 'Seite neu laden')}
          </Button>
        }
      />
    </WrapperWidget>
  );
}
